export const categories = [
  {
    id: 'talent',
    name: '才艺表演',
    icon: 'ri-music-2-line',
    description: '汇聚唱歌、舞蹈、乐器演奏等才艺主播，精彩的表演让你目不暇接',
    count: 156,
    color: 'bg-primary-500',
  },
  {
    id: 'gaming',
    name: '游戏陪玩',
    icon: 'ri-gamepad-line',
    description: '王者荣耀、LOL、原神等热门游戏主播，带你驰骋游戏世界',
    count: 128,
    color: 'bg-accent-500',
  },
  {
    id: 'lifestyle',
    name: '生活分享',
    icon: 'ri-heart-line',
    description: '美食探店、旅行Vlog、美妆护肤、日常穿搭，分享美好生活',
    count: 103,
    color: 'bg-secondary-500',
  },
  {
    id: 'chat',
    name: '聊天互动',
    icon: 'ri-chat-smile-2-line',
    description: '情感分析、星座解读、交友互动，找到属于你的专属陪伴',
    count: 89,
    color: 'bg-primary-500',
  },
  {
    id: 'fitness',
    name: '运动健身',
    icon: 'ri-run-line',
    description: '瑜伽、健身操、冥想放松，跟随专业教练一起健康生活',
    count: 67,
    color: 'bg-accent-500',
  },
  {
    id: 'education',
    name: '知识教学',
    icon: 'ri-book-open-line',
    description: '外语学习、编程教学、职业技能培训，在娱乐中收获成长',
    count: 54,
    color: 'bg-secondary-500',
  },
];